// import Vue from 'vue'
// import App from './App.vue'
import App from '@/App.vue'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'; /* 引入axios进行地址访问*/
import VueAxios from 'vue-axios'
// import VueRouter from 'vue-router'
import VDistpicker from 'v-distpicker'
// import mavonEditor from 'mavon-editor'
// import 'mavon-editor/dist/css/index.css'


// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'



 
// import htmlDocx from 'html-docx-js'
// import VueResource from 'vue-resource'
import MetaInfo from 'vue-meta-info';
import store from '@/store'
import 'element-ui/lib/theme-chalk/display.css';
// import echarts from "echarts";

 
 
// import Qs from 'qs';
// Vue.prototype.$qs = Qs;
axios.defaults.withCredentials=true;   //上线版本需要开启
axios.defaults.timeout = 15000;  
Vue.prototype.$http = axios;
// Vue.use(Qs)
// Vue.prototype.$echarts = echarts;

// Vue.use(mavonEditor) 
Vue.use(MetaInfo)
// Vue.use(VueQuillEditor, /* { default global options } */)
// Vue.use(VueRouter)
Vue.use(VueAxios,axios);

// Vue.use(Base64);
// Vue.use(VueAxios);
// Vue.use(ElementUI);

Vue.component('v-distpicker', VDistpicker)
Vue.config.productionTip = false

 

 

// const Foo = { template: '<div>foo</div>' }
// const Bar = { template: '<div>bar</div>' }

 

 

 

 


 
new Vue({
  render: h => h(App),
  // router,
  store,
  data() {
		return {
      userInfo:{},
      islogin:false,
      accountInfo:{},
      myColumnSub:'',
      // TOKEN:'',
      notice: { newMsg:0,newNotice:0},
      // rootUrl:'https://test.lawtip.cn/',
      rootUrl:'https://api.lawtip.cn/', 

      oa_rootUrl:'https://api.oalaw.cn/', 
      // isPhone:false, 
		}
  },
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app') 
